import { render } from "./QuestionnaireItem.vue?vue&type=template&id=1197f16d&scoped=true"
import script from "./QuestionnaireItem.vue?vue&type=script&lang=js"
export * from "./QuestionnaireItem.vue?vue&type=script&lang=js"

import "./QuestionnaireItem.vue?vue&type=style&index=0&id=1197f16d&lang=less&scoped=true"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1197f16d"]])

export default __exports__